import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import useEventMaybeEmailPreview from '../../utils/event/useEventMaybeEmailPreview';
import Form from './Form';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';

EventMaybeDialog.propTypes = {
  event: PropTypes.object.isRequired,
  invitation: PropTypes.object.isRequired
};

export default function EventMaybeDialog(props) {
  const { event, invitation } = props;

  const [data, setData] = useState({
    customMessage: 'Maybe, but I have some questions first.'
  });
  const [showErrors, setShowErrors] = useState(false);

  const creator = useConnect('user.byId', {
    id: event.data.creatorId
  });

  const emailPreview = useEventMaybeEmailPreview(event, creator, data.customMessage);

  const mutation = useQueryMutation('invitation.update', invitation);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      props.onCancel();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate({
      response: 'Maybe',
      responseMessage: data.customMessage
    });
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  onChange = onChange.bind(data);

  return (
    <DialogTemplate className="w-screen max-w-screen-sm">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          customMessage: [validators.isRequired]
        }}>
          {({errors, hasError}) => (
            <Form
              data={data}
              errors={errors}
              showErrors={showErrors}
              onChange={onChange}
              onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
              onCancel={props.onCancel}
              alert={error ? (
                <RequestError request={request}/>
              ) : showErrors ? (
                <ErrorMessage>
                  Please fill in all required fields.
                </ErrorMessage>
              ) : (false && success) ? (
                <SuccessMessage>
                  Idea created.
                </SuccessMessage>
              ) : null}
              invitation={invitation}
              emailPreview={emailPreview}
              creator={creator}
            />
          )}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
